import React from "react";
import AdmLessonPlan from "../../components/AdminTabs/AdminClassTimeTable/AdmLessonPlan";

function SchoolFees() {
  return (
    <div>
      <AdmLessonPlan listPath="/admin/lesson-plan-list" />
    </div>
  );
}

export default SchoolFees;
